import {CancelToken} from '../../../../helpers/asyncCancelHelpers';
import {ApiCustomField} from '../../../../models/api/customFieldModel';
import {postApiAsync} from '../../../../services/http/http';
import {RuleRecipePlaceholder, RuleRecipePlaceholderTypesEnum} from '../../library/recipes/builder';

/*
 * Service.
 */

export class CustomFieldsService {
  static createPlaceholder(
    placeholder: RuleRecipePlaceholder<RuleRecipePlaceholderTypesEnum.CUSTOM_FIELD>,
    companyUrl: string,
    cancelToken: CancelToken,
  ) {
    const {resourceType, name, defaultDescription: description, type} = placeholder.params;

    const url = `${companyUrl}/${resourceType}/custom_fields`;
    return postApiAsync(ApiCustomField, url, {name, description, type}, {cancelToken});
  }
}
